const TeamLeadOption = [
    {
        label: 'Courtney Henry'
    },
    {
        label: 'Wade Warren'
    },
    {
        label: 'Eleanor Pena'
    },
    {
        label: 'Ralph Edwards'
    }
];
const TeamManagerOption = [
    {
        label: 'Wade Warren'
    },
    {
        label: 'Guy Hawkins'
    },
    {
        label: 'Kathryn Murphy'
    },
    {
        label: 'Darrell Steward'
    }
];

const initialValues = {
    roleName: '',
    description: '',
    type: ''
};
const roleTypes = [
    {
        label: 'Executive',
        value: 'EXECUTIVE'
    },
    {
        label: 'Manager',
        value: 'MANAGER'
    },
    {
        label: 'Lead',
        value: 'LEAD'
    }
];
const roleTableData = [

    {
        key: 'user',
        user: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'product',
        product: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'po',
        po: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'inventry',
        inventry: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'task',
        task: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'so',
        so: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'internal_transfer',
        internal_transfer: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'return',
        return: {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    },
    {
        key: 'rough-listing',
        'rough-listing': {
            all: false,
            view: false,
            create: false,
            update: false,
            delete: false
        }
    }
];
export { TeamLeadOption, TeamManagerOption, initialValues, roleTypes, roleTableData };
